import { Config } from '../config';

class InvoiceImageService {
  public apiBaseUrl: string;

  constructor() {
    // Use the API base URL from config
    this.apiBaseUrl = Config.Env.ApiBaseUrl;
  }

  /**
   * Get the download URL for an image
   * @param imagePath The storage path of the image
   * @returns Promise with the image URL
   */
  async getImageUrl(imagePath: string): Promise<string> {
    try {
      // Use the public endpoint that doesn't require authentication
      const response = await fetch(`${this.apiBaseUrl}/invoices/images/${encodeURIComponent(imagePath)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status !== 'success' || !data.data?.imageUrl) {
        throw new Error(data.message || 'Failed to get image URL');
      }

      return data.data.imageUrl;
    } catch (error) {
      console.error('Error getting invoice image URL:', error);
      throw error;
    }
  }
}

export default InvoiceImageService;